import { render, staticRenderFns } from "./ManagerReportFormTab.vue?vue&type=template&id=763e553a&"
import script from "./ManagerReportFormTab.vue?vue&type=script&lang=js&"
export * from "./ManagerReportFormTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports